import { FreeipaService } from '@/api/freeipa';
import { TasklistService } from '@/api/tasklist';
import { SelectField } from '@/components/form/fields/SelectField';
import { TextAreaField } from '@/components/form/fields/TextAreaField';
import { FormContainer } from '@/components/form/FormContainer';
import { SubmitButton } from '@/components/ui/Button';
import { MyTaskContextNew } from '@/pages/task/MyTask';
import { TasklistMyTaskContext } from '@/pages/tasklist/TasklistMyTask';
import { zodResolver } from '@hookform/resolvers/zod';
import { Button, Modal } from 'alurkerja-ui';
import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

type Props = {
  processKey: string;
  taskId: string;
  refetch?: () => void;
};

const modelDelegatePayloadSchema = z.object({
  userId: z.string({ required_error: 'This field is required' }),
  reason: z.string({ required_error: 'This field is required' }).min(5),
});
type ModelDelegatePayloadSchema = z.infer<typeof modelDelegatePayloadSchema>;

const ModalDelegateTask: React.FC<Props> = ({ processKey, taskId, refetch }) => {
  const { refetchMyTask } = useContext(MyTaskContextNew);
  const { refetchTasklistMyTask } = useContext(TasklistMyTaskContext);

  const form = useForm<ModelDelegatePayloadSchema>({
    resolver: zodResolver(modelDelegatePayloadSchema),
  });

  const { data: employees } = FreeipaService.useGetEmployees();
  const employeeOptions = employees?.map(employee => ({
    label: employee.fullname,
    value: employee.username,
  }));

  const { mutate, isLoading } = TasklistService.useDelegateTask<ModelDelegatePayloadSchema>({
    onSuccess: () => {
      refetch?.();
      refetchMyTask?.();
      refetchTasklistMyTask?.();
    },
  });

  const handleSubmit = (payload: ModelDelegatePayloadSchema) => {
    mutate({
      processDefinitionKey: processKey,
      taskId,
      body: payload,
    });
  };

  return (
    <Modal
      title={'Delegate Task'}
      maxWidth="xl"
      triggerButton={
        <Button className="rounded-full pl-0 pr-0 sm:px-2" size="small" variant="text">
          Delegate
        </Button>
      }
    >
      <div className="p-6">
        <FormContainer form={form} onSubmit={handleSubmit} className="space-y-4">
          <SelectField
            name="userId"
            options={employeeOptions}
            label="Assignee Baru"
            placeholder="pilih assignee tujuan"
            isSearchable
          />
          <TextAreaField name="reason" label="Alasan" placeholder="masukkan alasan" />

          <div className="flex justify-end">
            <SubmitButton loading={isLoading}>Submit</SubmitButton>
          </div>
        </FormContainer>
      </div>
    </Modal>
  );
};

export default ModalDelegateTask;
